import isEmpty from "../../lib/isEmpty";
export const Validation = value => {
    let errors = {};
    
    if (isEmpty(value.toCurrencyId)) {
        errors.message = "TO_CURRENCY_REQUIRED"
    }
    if (isEmpty(value.amount)) {
        errors.message = "AMOUNT_REQUIRED"
    } else if (isNaN(value.amount)) {
        errors.message = "VALID_AMOUNT"
    } else if (value.amount <= 0) {
        errors.message = "AMOUNT_CAN'T_ZERO";
    }


    return errors;
}
